import React, {useMemo} from 'react';
import styled from 'styled-components';

import ProductTab from 'components/pages/product/productTab';

import theme, {bp, color} from 'settings/theme';


type Props = {
  product: any,
  activeTab: string
};

// Product Header
const Component: React.FC<Props> = (props) => {

  return (

    <StyledComponent className="productTabs">
      <ProductTab product={props.product} label="DETAILS" name="details" activeTab={props.activeTab} />
      <ProductTab product={props.product} label="PRICING" name="pricing" activeTab={props.activeTab} />
      <ProductTab product={props.product} label="SPECS" name="specs" activeTab={props.activeTab} />
      <ProductTab product={props.product} label="REVIEWS" name="reviews" activeTab={props.activeTab} />
      <ProductTab product={props.product} label="DELIVERY" name="delivery" activeTab={props.activeTab} />
    </StyledComponent>
  
  );

};

export default Component;


// Styles
const StyledComponent = styled.div`

  display: flex;
  align-items: stretch;
  height: 100%;

  @media (min-width: ${bp(3)}) {

    border-left: solid 1px ${color.lines};

  }

`;



